import { VERIFICADNI_LOGOUT } from "../../ActionTypes";

export const logoutVerificaDni = () => (dispatch) => {  
  dispatch({ type: VERIFICADNI_LOGOUT });
};
